import { Alert, AlertDescription, AlertTitle } from "@chakra-ui/react";
import { AlertIcon } from "view-layer/components/common/icons/AlertIcon";

export const LinkExpired = () => (
  <Alert status="warning" variant="warning" data-testid="payment-expired-message">
    <AlertIcon status="warning" />
    <AlertTitle>Link expired</AlertTitle>
    <AlertDescription>Please contact the property for more information.</AlertDescription>
  </Alert>
);